import Smart from 'hocs/smart';
import { latestReportForAsset } from 'selectors/reports';
import MeasurementPanel from './measurementPanel-view';

export default Smart(
  MeasurementPanel,
  (state, ownProps) => ({
    organisationId: state.session.organisationId,
    cursor: state.positions.cursor,
    selectedItemId: state.app.selectedItem?.id,
    selectedTimezone: state.settings.locale.timezone,
    measurementMarker: state.map.measurementMarkers[ownProps.mapId].currentMeasurementMarker,
    selectedAssets: state.map.selectedAssets,
  }),
  () => ({ })
);
